import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="w-full px-4 md:px-8 py-20 md:py-28 text-center animate-fade-in">
      <p className="font-heading text-7xl md:text-9xl font-black text-primary-100 select-none">
        404
      </p>
      <h1 className="mt-4 font-heading text-xl md:text-3xl font-bold text-foreground-950">
        页面走丢了
      </h1>
      <p className="mt-3 text-sm text-foreground-500">
        抱歉，没有找到路径 <span className="text-foreground-700">{location.pathname}</span> 对应的内容
      </p>
      <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium px-5 py-2.5 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
        <Link
          to="/search"
          className="inline-flex items-center gap-1.5 rounded-md border border-background-300 hover:border-primary-400 text-foreground-800 text-sm font-medium px-5 py-2.5 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-search-line" />
          去搜索影视
        </Link>
      </div>
    </div>
  );
}